import { preloadHomeWidgets } from './preloadHomeWidgets';

export const preloadSidePanel = ({ isLicensed }: { isLicensed: boolean }) => {
	return preloadHomeWidgets({ isLicensed });
};
